module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v("Public Files")]), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn btn-sm btn-primary",
    on: {
      "click": _vm.uploadNewFile
    }
  }, [_vm._v("\n            Upload file\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn btn-sm btn-primary",
    on: {
      "click": _vm.updateFileStructure
    }
  }, [_vm._v("\n            Update list\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.rootTree) ? _c('div', {
    staticClass: "file-manager"
  }, [_vm._l((_vm.rootTree.folders), function(content, name) {
    return _c('SelectelFolder', {
      key: name,
      attrs: {
        "name": name,
        "path": name,
        "content": content
      },
      on: {
        "folderDeleted": _vm.onFolderDeleted,
        "fileDeleted": _vm.onFileDeleted
      }
    })
  }), _vm._v(" "), _vm._l((_vm.rootTree.files), function(file) {
    return _c('File', {
      key: file.basename,
      attrs: {
        "file": file
      },
      on: {
        "fileDeleted": _vm.onFileDeleted
      }
    })
  })], 2) : _vm._e()], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d9b20d9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/publicFiles/Index.vue
// module id = 917
// module chunks = 0